document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', function(e) {
    const wrapper = e.target.closest('.video-lazy');
    if (!wrapper) return;

    let src = wrapper.dataset.src;
    // Ensure it’s an embed URL
    if (!src.includes('/embed/')) {
      const match = src.match(/(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      if (match) src = `https://www.youtube.com/embed/${match[1]}?autoplay=1&rel=0&showinfo=0&controls=0&modestbranding=1&playsinline=1&mute=1`;
    } else {
      src += '?autoplay=1&rel=0&showinfo=0&controls=0&modestbranding=1&playsinline=1&mute=1';
    }

    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    wrapper.innerHTML = '';
    wrapper.appendChild(iframe);
  });
});
